<template>
  <div class="stock__product product">
    <router-link
      v-if="item.product.id && groupFamilyExists(item.product.family.id) == true"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos && item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div v-else-if="item.product.id" class="product__image-container">
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos && item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </div>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
      </div>
      <p class="product__code">
        <img
          src="/static/img/pictos/reapprobleufonce.svg"
          alt=""
          v-if="
            item.vehicleStocks &&
            item.vehicleStocks.length == 1 &&
            item.vehicleStocks[0].restocking == 1
          "
        />
        Code article : {{ item.product.code }}
      </p>
    </div>
    <div class="product__stock-container">
      <div class="product__stock stock">
        <div v-if="item.stock < item.min_stock" class="stock__picto red">
          <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
        </div>
        <div v-else-if="item.stock == item.min_stock" class="stock__picto orange">
          <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
        </div>
        <div v-else class="stock__picto green">
          <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
        </div>
        <span class="stock__text">Etat du stock</span>
        <span class="stock__number">{{ item.stock }}</span>
      </div>
    </div>
    <div class="product__btns">
      <router-link
        v-if="
          item.product.product_shops[0].available &&
          item.id &&
          groupFamilyExists(item.product.family.id) == true
        "
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
      <div v-else class="product__btn product__btn--see">
        <img src="/static/img/pictos/fermer-bleu.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductStock",
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    groupFamilyExists(id) {
      let me = this.$store.getters["auth/user"];
      let authorise = false;

      if (typeof me == "string") {
        me = JSON.parse(me);
      }
      for (var i = 0; i < me.group.families.length; i++) {
        if (me.group.families[i]["id"] == id) {
          authorise = true;
        }
      }
      return authorise;
    },
  },
  computed: {
    me: function () {
      let me = this.$store.getters["auth/user"];
      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  background-color: white;
  width: 100%;
  padding-bottom: 20px;
  height: auto;
  border: 1px solid $grisclair;
  margin-bottom: 60px;
  &__image-container {
    width: 50%;
    height: 100%;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 50%;
    height: 100%;
    padding: 20px;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      width: 100%;
      line-height: 1;
    }
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: 20px;
    width: 100%;
    position: absolute;
    bottom: -40px;
  }
  &__stock-container {
    padding-top: 15px;
    display: flex;
    align-items: last baseline;
    width: 100%;
  }
  .stock {
    width: 100%;
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    &__picto {
      width: 40px;
      margin-left: 20px;
      position: relative;
      img {
        width: 100%;
      }
      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -10px;
        margin-top: -10px;
        border-radius: 50%;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
    }
    &__text {
      margin: 0 10px;
      font-size: 12px;
    }
    &__number {
      width: 70px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      border: 1px solid $grisclair;
      border-radius: 50%;
      font-family: "ClanFFBlack";
      font-size: 20px;
    }
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    &--see {
      background-color: $color2;
    }
    &--add {
      background-color: $color3;
    }
    img {
      width: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductStock.vue